<template>
    <div>
        <context-menu id="component-list-context-menu">
            <template v-slot:default="{ data } ">
                <context-menu-item
                    v-if="data && data.isFolder"
                    text="Add Folder"
                    icon="folder-plus"
                    @click="onAdd(data)"
                />

                <context-menu-item
                    v-if="data && !data.isRoot"
                    text="Rename"
                    icon="pencil"
                    @click="onEdit(data)"
                />

                <!--
                    // This will be implemented in SAASLMM-1400

                    <context-menu-item
                    v-if="data && !data.isFolder"
                    text="Move"
                    icon="arrows"
                    @click="onCopy(data)"
                /> -->

                <context-menu-item
                    v-if="data && !data.isFolder && !data.isRoot"
                    text="Copy"
                    icon="copy"
                    @click="onCopy(data)"
                />

                <context-menu-item
                    v-if="data && !data.isRoot"
                    text="Delete"
                    icon="trash"
                    :disabled="data.element && data.element.children.length > 0"
                    @click="onDelete(data)"
                />
            </template>
        </context-menu>
    </div>
</template>

<script>
import ContextMenu from '@/components/utilities/context-menu';
import ContextMenuItem from '@/components/utilities/context-menu-item';

export default {
    name: 'component-list-context-menu',
    components: { ContextMenu, ContextMenuItem },

    computed: {
    },

    methods: {
        onAdd(data) {
            if (data && data.onAddCallback) {
                data.onAddCallback(data);
            }
        },
        onEdit(data) {
            if (data && data.onEditCallback) {
                data.onEditCallback();
            }
        },
        onCopy(data) {
            if (data && data.onCopyCallback) {
                data.onCopyCallback();
            }
        },
        onDelete(data) {
            if (data && data.onDeleteCallback) {
                data.onDeleteCallback();
            }
        },
    },
};
</script>
